import { render } from "./PrintedHeader.vue?vue&type=template&id=616a7e6d&scoped=true&lang=pug"
import script from "./PrintedHeader.vue?vue&type=script&lang=ts"
export * from "./PrintedHeader.vue?vue&type=script&lang=ts"

import "./PrintedHeader.vue?vue&type=style&index=0&id=616a7e6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-616a7e6d"

export default script